// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBox_container__7oAo_","inner":"ContentBox_inner__eYkIk","noPadding":"ContentBox_noPadding__P_gkg"};